import { combineReducers } from 'redux';
import AuthReducer from './authReducer';
import AlertReducer from './alertReducer.js';
import ShowModels from './showModels.js'

export default combineReducers({
  auth: AuthReducer,
  alert: AlertReducer,
  ShowModels: ShowModels
});
